import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			redirect: '/home'
		},
		{
			path: '/home',
			name: 'home',
			component: () => import('./views/home/home'),
			meta: {
				title: '首页',
			}
		},
		{
			path: '/auction/:type/:id',
			name: 'auction',
			component: () => import('./views/auction/auction.vue'),
			meta: {
				title: '资产竞拍',
			}
		},
		{
			path: '/auctionDetail/:type/:id',
			name: 'auctionDetail',
			component: () => import('./views/auctionDetail/auctionDetail.vue'),
			meta: {
				title: '资产竞拍详情',
			}
		},
		{
			path: '/aboutUs/:id',
			name: 'aboutUs',
			component: () => import("./views/aboutUs/AboutUs.vue"),
			meta: {
				title: '关于我们',
			}
		},
		{
			path: '/subDetail/:id',
			name: 'subDetail',
			component: () => import('./views/subDetail/subDetail'),
			meta: {
				// keepAlive: true,
				title: '拍卖公告',
			}
		},
		// {
		// 	path: '/auctionSec',
		// 	name: 'auctionSec',
		// 	component: () => import('./views/auctionSec/auctionSec.vue'),
		// 	meta: {
		// 		title: '资产竞拍',
		// 	}
		// },
		// {
		// 	path: '/auctionSecDetail',
		// 	name: 'auctionSecDetail',
		// 	component: () => import('./views/auctionSecDetail/auctionSecDetail.vue'),
		// 	meta: {
		// 		title: '资产竞拍详情',
		// 	}
		// },
		{
			path: '/help/:id',
			name: 'help',
			component: () => import('./views/help/help.vue'),
			meta: {
				title: '帮助中心',
			}
		},
		{
			path: '/lease',
			name: 'lease',
			component: () => import('./views/lease/lease.vue'),
			meta: {
				title: '帮助中心',
			}
		},
		{
			// path: '/deal/:id',
			path: '/deal',
			name: 'deal',
			component: () => import('./views/deal/deal.vue'),
			meta: {
				title: '交易服务',
			}
		},
		{
			path: '/lawyer',
			name: 'lawyer',
			component: () => import('./views/lawyer/lawyer.vue'),
			meta: {
				title: '律师调解',
			}
		},
		{
			path: '/new',
			name: 'new',
			component: () => import('./views/new/new.vue'),
			meta: {
				title: '新房',
			}
		},
		{
			path: '/newDetail/:id',
			name: 'newDetail',
			component: () => import('./views/newDetail/newDetail.vue'),
			meta: {
				title: '新房详情',
			}
		},
		{
			path: '/second',
			name: 'second',
			component: () => import('./views/second/second.vue'),
			meta: {
				title: '二手房',
			}
		},
		{
			path: '/secondDetail/:id',
			name: 'secondDetail',
			component: () => import('./views/secondDetail/secondDetail.vue'),
			meta: {
				title: '二手房详情',
			}
		},
		{
			path: '/rent',
			name: 'rent',
			component: () => import('./views/rent/rent.vue'),
			meta: {
				title: '租房',
			}
		},
		{
			path: '/rentDetail/:id',
			name: 'rentDetail',
			component: () => import('./views/rentDetail/rentDetail.vue'),
			meta: {
				title: '租房详情',
			}
		},
		// {
		// 	path: '/rentDetail/:id',
		// 	name: 'rentDetail',
		// 	component: () => import('./views/rentDetail/rentDetail.vue'),
		// 	meta: {
		// 		title: '租房详情',
		// 	}
		// },
		{
			path: '/register',
			name: 'register',
			component: () => import('./views/register/register.vue'),
			meta: {
				title: '注册',
			}
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('./views/LoginRegister/LoginRegister.vue'),
			meta: {
				title: '登录注册',
			}
		}, {
			path: '/personal/:id',
			name: 'personal',
			component: () => import('./views/personal/personal.vue'),
			meta: {
				title: '个人中心',
			}
		},
		{
			path: '/expert',
			name: 'expert',
			component: () => import('./views/expert/expert.vue'),
			meta: {
				title: '专家团队',
			}
		},
		{
			path: '/flow',
			name: 'flow',
			component: () => import('./views/flow/flow.vue'),
			meta: {
				title: '竞拍流程',
			}
		},

		{
			path: '/resetPwd',
			name: 'resetPwd',
			component: () => import('./views/resetPwd/resetPwd.vue'),
			meta: {
				title: '重置密码',
			}
		},
		{
			path: '/resetsuccess',
			name: 'resetsuccess',
			component: () => import('./views/resetsuccess/resetsuccess.vue'),
			meta: {
				title: '重置成功',
			}
		},

	]
})
